<template>
  <div>
    <div v-if="isVisual" class="base-timer">
      <svg class="base-timer__svg" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
        <g class="base-timer__circle">
          <circle class="base-timer__path-elapsed" cx="50" cy="50" r="45"></circle>
          <path
            :stroke-dasharray="circleDasharray"
            class="base-timer__path-remaining"
            :class="remainingPathColor"
            d="
              M 50, 50
              m -45, 0
              a 45,45 0 1,0 90,0
              a 45,45 0 1,0 -90,0
            "
          ></path>
        </g>
      </svg>
      <span class="base-timer__label">{{ formattedTimeLeft }}</span>
    </div>
    <div class="simple-timer" v-else>
      {{ formattedTimeLeft }}
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { EventBus } from '../../event-bus';

const FULL_DASH_ARRAY = 283;
const WARNING_THRESHOLD = 10;
const ALERT_THRESHOLD = 5;

const COLOR_CODES = {
  info: {
    color: 'green',
  },
  warning: {
    color: 'orange',
    threshold: WARNING_THRESHOLD,
  },
  alert: {
    color: 'red',
    threshold: ALERT_THRESHOLD,
  },
};

export default {
  data() {
    return {
      timeLimit: 60,
      timePassed: 0,
      timerInterval: null,
    };
  },

  computed: {
    ...mapState(['visualSchedule', 'subtaskCounterOptions']),

    circleDasharray() {
      return `${(this.timeFraction * FULL_DASH_ARRAY).toFixed(0)} 283`;
    },

    isVisual() {
      const subtask = this.subtaskCounterOptions.find((st) => st.id === this.visualSchedule.visual_schedule_subtask_id);
      return subtask.name.includes('Visual');
    },

    formattedTimeLeft() {
      const { timeLeft } = this;
      const minutes = Math.floor(timeLeft / 60);
      let seconds = timeLeft % 60;

      if (seconds < 10) {
        seconds = `0${seconds}`;
      }

      return `${minutes}:${seconds}`;
    },

    timeLeft() {
      return this.timeLimit - this.timePassed;
    },

    timeFraction() {
      const rawTimeFraction = this.timeLeft / this.timeLimit;
      return rawTimeFraction - (1 / this.timeLimit) * (1 - rawTimeFraction);
    },

    remainingPathColor() {
      const { alert, warning, info } = COLOR_CODES;

      if (this.timeLeft <= alert.threshold) {
        return alert.color;
      } if (this.timeLeft <= warning.threshold) {
        return warning.color;
      }
      return info.color;
    },
  },

  watch: {
    timeLeft(newValue) {
      if (newValue === 0) {
        this.onTimesUp();
      }
    },
  },

  mounted() {
    EventBus.$on('timer-state', this.handleTimerState);
    EventBus.$on('timer-duration', this.handleTimerSettingDuration);
    EventBus.$on('timer-reset', this.reset);
  },

  destroyed() {
    EventBus.$off('timer-state', this.handleTimerState);
    EventBus.$off('timer-duration', this.handleTimerSettingDuration);
    EventBus.$off('timer-reset', this.reset);
  },

  methods: {
    handleTimerState(running) {
      if (running) {
        this.startTimer();
      } else {
        this.clearTimer();
      }
    },

    handleTimerSettingDuration(duration) {
      this.timeLimit = duration;
    },

    onTimesUp() {
      EventBus.$emit('timer-up');
      this.clearTimer();
    },

    reset() {
      this.clearTimer();
      this.timePassed = 0;
    },

    startTimer() {
      this.clearTimer();
      this.timerInterval = setInterval(() => {
        this.timePassed += 1;
      }, 1000);
    },

    clearTimer() {
      if (this.timerInterval) clearInterval(this.timerInterval);
    },
  },
};
</script>
